/** @format */

import React from "react";
import { Button, Text } from "@mantine/core";
import {
  createDocument,
  getLink,
  shareLink,
  grantPermission,
  fetchDocsPermission,
  fetchDocsfetchRevisions,
  fetchDocsContent,
  deleteDocsPermission,
  fetchDocsContentBase64,
} from "../../utilities/apis/googleDocs";
import { fetchRevisionsHistoryLinks } from "../../utilities/apis/agreements";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import { useParams } from "react-router-dom";
import { showNotification } from "@mantine/notifications";
import { useEffect, useState } from "react";

function Collaboration(docId) {
  const { agreementId } = useParams();
  const [docData, setDocData] = useState(null);
  const [revisionData, setRevisionData] = useState(null);
  const [permissionData, setPermissionData] = useState({
    emailAddress: "",
    role: "writer",
    type: "user",
  });
  const [uiConfigs, setUiConfigs] = useState({
    createDocumentLoading: false,
    grantPermissionLoading: false,
  });

  const documentId = docId.docId;
  const getLinkApi = async () => {
    try {
      const response = await apiWrapWithErrorWithData(getLink({ agreementId }));
      if (response.success) {
        setDocData(response.data);

        const documetEditorId = response?.data?.id;

        const fetchRevisions22 = await apiWrapWithErrorWithData(
          fetchDocsfetchRevisions(documetEditorId),
        );
        //
        setRevisionData(fetchRevisions22);
        // const revisionId="1";
        // const responseHistory = await apiWrapWithErrorWithData(fetchRevisionsHistoryLinks(documetEditorId, revisionId))
        //
        //const fetchRevisions = await apiWrapWithErrorWithData(fetchDocsContent(documetEditorId));
        //const deletePermissionResp = await apiWrapWithErrorWithData(deleteDocsPermission(documetEditorId));
        //const deletePermissionResp = await apiWrapWithErrorWithData(fetchDocsPermission(documetEditorId));
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (agreementId) {
      getLinkApi();
    }
  }, [agreementId]);

  const createDocumentApi = async () => {
    setUiConfigs((preState) => ({ ...preState, createDocumentLoading: true }));
    const response = await apiWrapWithErrorWithData(
      createDocument({ agreementId }),
    );

    if (response.success) {
      getLinkApi();
      showNotification({
        color: "green",
        message: "Google document created",
        title: "Google document",
      });
    }
    setUiConfigs((preState) => ({ ...preState, createDocumentLoading: false }));
  };

  const shareLinkApi = async () => {
    try {
      setUiConfigs((preState) => ({
        ...preState,
        grantPermissionLoading: true,
      }));

      const response = await apiWrapWithErrorWithData(
        shareLink({
          agreementId,
        }),
      );

      if (response.success) {
        showNotification({
          color: "green",
          message: "Agreement has been shared",
          title: "Google document",
        });
      }
    } catch (err) {}
    setUiConfigs((preState) => ({
      ...preState,
      grantPermissionLoading: false,
    }));
  };

  const viewRevisionHistoryDoc = async (url) => {
    // const responseHistory = await apiWrapWithErrorWithData(fetchRevisionsHistoryLinks(documentId, revisionId ));
    // if(responseHistory.success){
    //   const url = responseHistory.data.exportLinks["application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
    window.open(url, "_blank");
    // } else{
    //   showNotification({
    //     color: "red",
    //     title: 'Response Got Some Error!'
    //   })
    // }
  };
  let srnumber = 1;
  return (
    <>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "20px",
          }}
        >
          {/* {docData ? (
            <Button component="a" target="_blank" href={docData?.documentLink}>
              Edit
            </Button>
          ) : (
            <Button
              onClick={createDocumentApi}
              disabled={uiConfigs.createDocumentLoading}
            >
              Create Google Docs
            </Button>
          )} */}
        </div>
        {/* {docData ? (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "20px",
              }}
            >
              <Button
                color="green"
                onClick={shareLinkApi}
                disabled={uiConfigs.grantPermissionLoading}
              >
                Share agreement
              </Button>
            </div>
          </>
        ) : null} */}

        <div>
          <table
            style={{ textAlign: "center", marginTop: "20px", width: "100%" }}
          >
            <tr>
              <th>Revision Number</th>
              <th>Last Modified User</th>
              <th>Last Modified Email</th>
              <th>Last Modified</th>
              <th>Last Modified Document</th>
            </tr>
            {revisionData?.data?.map((history) => (
              <tr key={history.revisionId}>
                {history.revisionId > 1 ? (
                  <>
                    <td>{srnumber++}</td>
                    <td>
                      {srnumber > 2
                        ? history.lastModifyingUser
                        : "Agreement Created"}
                    </td>
                    <td>
                      {srnumber > 2
                        ? history.emailAddress
                        : "Agreement Created"}
                    </td>
                    <td>
                      <Text>
                        {new Date(history.modifiedDate).toLocaleDateString(
                          "en-IN",
                          { timeZone: "Asia/Kolkata" },
                        )}
                      </Text>
                      <Text>
                        {new Date(history.modifiedDate).toLocaleTimeString(
                          "en-IN",
                          { timeZone: "Asia/Kolkata" },
                        )}
                      </Text>
                    </td>
                    <td>
                      <Button
                        className="inline-block bg-blue-400 hover:bg-blue-500 text-white font-bold py-2 px-4 rounded"
                        onClick={() =>
                          viewRevisionHistoryDoc(
                            history.exportLinks[
                              "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            ],
                          )
                        }
                      >
                        View Doc
                      </Button>
                    </td>
                  </>
                ) : null}
              </tr>
            ))}
          </table>
        </div>
      </div>
    </>
  );
}

export default Collaboration;
